import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import { alias } from '@ember/object/computed';
import OfflineModeSettings from './offline-mode-settings';
import SignatureSettings from './signature-settings';
import TippingSettings from './tipping-settings';
export default ProtoBaseModel.extend({
  storeAndForward: attr(OfflineModeSettings),
  tipping: attr(TippingSettings),
  signature: attr(SignatureSettings),
  enableStandaloneMode: attr(Boolean, {
    defaultValue: false
  }),
  // TODO: There's got to be a cleaner way to do this...
  offlineMode: alias('storeAndForward')
});